var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"new-badge"},[_vm._v(" NEW ")])
}
var staticRenderFns = []

export { render, staticRenderFns }